import {
  CreditCard,
  LayoutGrid,
  Megaphone,
  Package,
  Receipt,
  ScanLine,
  Settings,
  ShoppingBag,
  Store,
  Truck,
  Users,
  Warehouse,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface NavEntry {
  /** Clave en `modules`. */
  module: string;
  path: string;
  label: string;
  icon: LucideIcon;
  group: "operacion" | "negocio" | "tienda";
  /** Se muestra en la barra inferior del movil. */
  mobile?: boolean;
}

/**
 * Mapa de modulo a destino. El orden lo decide `modules.sort_order` en la
 * base, no este archivo: aqui solo vive lo que la base no puede saber —
 * la ruta y el icono.
 *
 * Estan TODOS, contratados o no. La barra los pinta con candado cuando el plan
 * no los incluye: un cliente no puede pedir lo que no sabe que existe.
 */
export const NAV: NavEntry[] = [
  { module: "dashboard",      path: "/",              label: "Dashboard",     icon: LayoutGrid, group: "operacion" },
  { module: "orders",         path: "/ventas",        label: "Ventas",        icon: Receipt,    group: "operacion", mobile: true },
  { module: "catalog",        path: "/catalogo",      label: "Catálogo",      icon: Package,    group: "operacion", mobile: true },
  { module: "inventory",      path: "/inventario",    label: "Inventario",    icon: Warehouse,  group: "operacion", mobile: true },
  { module: "customers",      path: "/clientes",      label: "Clientes",      icon: Users,      group: "operacion", mobile: true },

  { module: "purchases",      path: "/compras",       label: "Compras",       icon: ShoppingBag, group: "negocio" },
  { module: "suppliers",      path: "/proveedores",   label: "Proveedores",   icon: Truck,      group: "negocio" },
  { module: "pos",            path: "/punto-de-venta", label: "Punto de venta", icon: ScanLine, group: "negocio" },

  { module: "marketing",      path: "/marketing",     label: "Marketing",     icon: Megaphone,  group: "tienda" },
  { module: "shipping",       path: "/entregas",      label: "Entregas",      icon: Truck,      group: "tienda" },
  { module: "payments",       path: "/pagos",         label: "Pagos",         icon: CreditCard, group: "tienda" },
  { module: "store_settings", path: "/configuracion", label: "Configuración", icon: Settings,   group: "tienda" },
];

export const GROUP_LABEL: Record<NavEntry["group"], string | null> = {
  operacion: null,
  negocio: "Negocio",
  tienda: "Tienda",
};

export const StoreIcon = Store;
